import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";

import "vuetify/dist/vuetify.min.css";
import vuetify from "./plugins/vuetify";

//map
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBiiuRsLj0E9-9ch_7haAbpmLYAM8lfDe0",
    libraries: "places"
  }
});

// import "mdbvue/build/css/mdb.css";
// import "bootstrap-css-only/css/bootstrap.min.css";

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faChevronUp,
  faCheck,
  faEllipsisH,
  faCircle,
  faTrashAlt,
  faShare,
  faEye,
  faBell,
  faPlusCircle,
  faSearch,
  faHashtag,
  faPause,
  faInfoCircle,
  faPencilAlt,
  faChartLine,
  faFileAlt,
  faUser,
  faCalendarWeek,
  faPowerOff
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faChevronUp,
  faCheck,
  faEllipsisH,
  faCircle,
  faTrashAlt,
  faShare,
  faEye,
  faBell,
  faPlusCircle,
  faSearch,
  faHashtag,
  faPause,
  faInfoCircle,
  faPencilAlt,
  faChartLine,
  faFileAlt,
  faUser,
  faCalendarWeek,
  faPowerOff
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
